export const SHOP_KINDS = {
  BAG_TILE_UPGRADE: 'bag-tile-upgrade',
  NEW_RANDOM_TILE: 'new-random-tile',
  REMOVE_BAG_TILE: 'remove-bag-tile',
  GAME_MODIFIER_GRANT: 'game-modifier-grant',
  SHOP_MODIFIER_GRANT: 'shop-modifier-grant',
  BOARD_MODIFIER_GRANT: 'board-modifier-grant',
};

export const SHOP_KIND_LABELS = {
  [SHOP_KINDS.BAG_TILE_UPGRADE]: 'Tile Upgrades',
  [SHOP_KINDS.NEW_RANDOM_TILE]: 'New Tiles',
  [SHOP_KINDS.REMOVE_BAG_TILE]: 'Remove Tiles',
  [SHOP_KINDS.GAME_MODIFIER_GRANT]: 'Game Modifiers',
  [SHOP_KINDS.SHOP_MODIFIER_GRANT]: 'Shop Modifiers',
  [SHOP_KINDS.BOARD_MODIFIER_GRANT]: 'Board Modifiers',
};

export const SHOP_KIND_CHIP_LABELS = {
  [SHOP_KINDS.BAG_TILE_UPGRADE]: 'Tile Upgrade',
  [SHOP_KINDS.NEW_RANDOM_TILE]: 'New Tile',
  [SHOP_KINDS.REMOVE_BAG_TILE]: 'Remove Tile',
  [SHOP_KINDS.GAME_MODIFIER_GRANT]: 'Game Modifier',
  [SHOP_KINDS.SHOP_MODIFIER_GRANT]: 'Shop Modifier',
  [SHOP_KINDS.BOARD_MODIFIER_GRANT]: 'Board Modifier',
};
